import React, {useState} from 'react';
import {PulseAttachmentViewModel} from "../../viewModel/PulseView.model";

import './PulseImageView.scss';
import {IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLoading, IonModal, IonTitle, IonToolbar, useIonToast} from "@ionic/react";
import {close, download} from "ionicons/icons";
import {Media, MediaSaveOptions} from "@capacitor-community/media";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";


export interface PulseImageViewProps{
    pulseMessage: string;
    pulseAttachment: PulseAttachmentViewModel;
    pulseThumbnail: PulseAttachmentViewModel,
}

export function PulseImageView({pulseMessage, pulseAttachment, pulseThumbnail}: PulseImageViewProps) {
    const [present] = useIonToast();
    let downLoadingImage = false;
    const [showImageModal, setShowImageModal] = useState(false);


    const downloadImage = async (e: any) => {
        e.stopPropagation();

        try {
            downLoadingImage = true;
            const ALBUM_NAME = "Event Pulse";
            // Step 2: Fetch existing albums
            let albums = await Media.getAlbums();
            let album: any = albums.albums?.find(a => a.name === ALBUM_NAME);

            // Step 3: Create album if it doesn't exist
            if (!album) {
                await Media.createAlbum({ name: ALBUM_NAME });
                albums = await Media.getAlbums();
                album = albums.albums?.find(a => a.name === ALBUM_NAME);
            }

            const albumIdentifier = album.identifier;
            if (!albumIdentifier) {
                throw new Error('Album identifier is missing');
            }

            const opts: MediaSaveOptions = { path: pulseAttachment.s3Location, albumIdentifier: albumIdentifier};
            await Media.savePhoto(opts);

            downLoadingImage = false;

            present({
                message: 'Image Saved To The Album "Event Pulse"',
                duration: 3000,
                position: 'bottom',
            });

        } catch (e: any) {
            console.log('MESSAGE HERE -> ' + e.message);
            present({
                message: 'Something went wrong downloading the image. Please check app permissions',
                duration: 3000,
                position: 'bottom',
            });
        }
        // saveAs(blob, pulse.attachments.fileName);

    }

    const closeImageModal = (e: any) => {
        e.stopPropagation();
        setShowImageModal(false);
    }


    return (
        <>
            <IonLoading
                isOpen={downLoadingImage}
                message="Downloading Image..."
                spinner="crescent"
                duration={0}
                backdropDismiss={false}
            />

            <div className="ion-padding event-pulse-pulse-image-container" onClick={e => {
                e.stopPropagation();
                console.log('div');
            }}>
                <img src={pulseThumbnail.s3Location} alt=""
                    onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log('img');
                        setShowImageModal(true);
                    }}/>
            </div>
            <div className={"ion-text-center"}>
                <em>{pulseMessage}</em>
            </div>


            <IonModal isOpen={showImageModal} onDidDismiss={closeImageModal}>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot={"start"}>
                            <IonButton shape="round" fill="clear" mode="ios" color="dark" onClick={closeImageModal}>
                                <IonIcon icon={close} style={{fontSize: "28px"}}/>
                            </IonButton>
                        </IonButtons>
                        <IonTitle onClick={(e) => e.stopPropagation()}>
                            Photo Preview
                        </IonTitle>
                        <IonButtons slot={"end"}>
                            <IonButton
                                shape="round"
                                fill="clear"
                                mode="ios"
                                color="dark"
                                onClick={downloadImage}>
                                <IonIcon icon={download} slot="icon-only" style={{fontSize: "28px"}}/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <div id="photo-content" onClick={e => e.stopPropagation()}>
                        <div style={{width: "100vw", height: "100vh", overflow: "hidden"}}>
                            <TransformWrapper
                                initialScale={0.9}
                                minScale={0.5}
                                maxScale={5}
                                centerOnInit
                                limitToBounds={false}
                            >
                                <TransformComponent
                                    wrapperStyle={{width: "100%", height: "100%"}}
                                    contentStyle={{width: "100%", height: "100%"}}
                                >
                                    <img
                                        src={pulseAttachment.s3Location}
                                        alt="Zoomable"
                                        style={{width: "100%", height: "100%", objectFit: "contain"}}
                                    />
                                </TransformComponent>
                            </TransformWrapper>
                        </div>
                    </div>
                </IonContent>
            </IonModal>
        </>
    );
}
